import Image from 'next/image';
import { Text, useThemeName } from '@frameio/vapor';
import { useIsSemanticSearchEnabled } from '../../../../shared/hooks';
import TEXT from './generated/TEXT/IntroBlock';
import styles from './IntroBlock.module.css';

const ImageDark =
  'https://static-assets.frame.io/web-app/search-intro-dark.png';
const ImageLight =
  'https://static-assets.frame.io/web-app/search-intro-light.png';

TEXT.DEFINE({
  /** Alt text for search illustration image */
  imageAlt: 'Search illustration',
  /** Main title for the search intro block */
  title: 'Meet the redesigned search—find what you need fast.',
  subtitle: {
    /** Default subtitle when semantic search is disabled */
    default: 'Precisely track down a file, status, assignee, and more.',
    /** Subtitle when semantic search is enabled */
    semantic:
      'Use natural language to locate files by status, transcripts, comments and more.',
  },
});

type IntroBlockProps = {
  isCompact: boolean;
};

export const IntroBlock = ({ isCompact }: IntroBlockProps) => {
  const isSemanticSearchEnabled = useIsSemanticSearchEnabled();
  const systemTheme = useThemeName();

  const isDark = systemTheme === 'dark';
  const imageSrc = isDark ? ImageDark : ImageLight;

  const subtitle = isSemanticSearchEnabled
    ? TEXT.subtitle.semantic
    : TEXT.subtitle.default;

  return (
    <div className={styles.introWrapper} data-is-compact={isCompact}>
      <div className={styles.card}>
        <div className={styles.imageWrapper}>
          <Image
            alt={TEXT.imageAlt}
            height={600}
            loader={({ src }) => src}
            loading="eager"
            sizes="(max-width: 768px) 100vw, 600px"
            src={imageSrc}
            width={600}
          />
        </div>
        <div className={styles.textContainer}>
          <div className={styles.titleWrapper}>
            <Text
              color="primary"
              style={{ textWrap: 'balance' }}
              variant="titleSmall"
            >
              {TEXT.title}
            </Text>
          </div>
          <div className={styles.subtitleWrapper}>
            <Text color="tertiary" variant="body">
              {subtitle}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
